module.exports = "agm-map {\n  height: 850px; }\n"